import React, { Fragment, useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import { useHistory } from "react-router-dom";

//material ui

import {
  Stack,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid,
  TextField,
  Card,
  Typography,
  CircularProgress,
  Tab,
  Tabs,
  Box,
  Checkbox,
  FormControlLabel,
  Button,
  Container,
  Divider,
  Paper,
  Fade,
  Collapse,
  LinearProgress,
  Avatar
} from '@mui/material';
import Alert from '@material-ui/lab/Alert';
//icons
import { FiArrowLeftCircle, FiUser, FiMapPin, FiCreditCard, FiSearch, FiTruck, FiShoppingBag, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
//redux
import { useDispatch, useSelector } from "react-redux";
//actions
import Actions from "../../constants/Actions";
import buscaCep from "../../actions/buscaCep";
import criarCliente from '../../actions/cadastro/criar-cliente'
//services
import { getCepUser, getDataUsuario, getIsMaquininhaUser } from '../../services/auth'
//utils
import { validaParcelas, getValorTotal, mascararTel, soNumeros, maskCPF, maskDate, validarCPF, phoneMask, getValorSubTotal } from '../../utils/functions';
//components
import Stepper from "../../components/Stepper";
import CartResumo from '../../components/CartResumo';
// actions novo
import criarPedido from '../../actions/pedidos/criar-pedido';
import buscarClientePorCpfLinx from '../../actions/cadastro/buscar-cliente-por-cpf-linx';
import consultarClientePorCpf from '../../actions/cadastro/consultar-cliente-cpf';
import editarCliente from '../../actions/cadastro/editar-cliente';
import actionLoginMoovpay from '../../actions/moovpay/actionLoginMoovpay';
import CheckoutShipping from '../../sections/checkout/CheckoutShipping';
import v2_actionCliente from '../../actions/v2/clientes/v2_actionCliente';

const moment = require('moment');

// ====== Design System Tokens ======
const BRAND = '#1a1a2e';
const BRAND_HOVER = '#16213e';
const BRAND_LIGHT = '#e8eaf0';
const ACCENT = '#0ea5e9';

const sectionHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  mb: 2.5,
  mt: 1,
};

const sectionIconSx = {
  width: 36,
  height: 36,
  bgcolor: BRAND_LIGHT,
  color: BRAND,
  fontSize: 18,
};

const cardSx = {
  p: { xs: 2.5, md: 3 },
  borderRadius: 2.5,
  border: '1px solid',
  borderColor: 'grey.200',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
};

const inputSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 1.5,
    '&.Mui-focused fieldset': { borderColor: BRAND },
  },
  '& .MuiInputLabel-root.Mui-focused': { color: BRAND },
};

const ItemPaymentType = ({ title, onClick, background, disabled }) => {
  const isSelected = !!background;
  return (
    <Paper
      elevation={0}
      onClick={disabled ? undefined : onClick}
      sx={{
        borderRadius: 2,
        p: 2,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        border: '2px solid',
        borderColor: isSelected ? BRAND : 'grey.300',
        bgcolor: isSelected ? BRAND_LIGHT : '#fff',
        transition: 'all 0.15s ease',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 100,
        position: 'relative',
        '&:hover': {
          borderColor: BRAND,
          bgcolor: BRAND_LIGHT,
        },
      }}
    >
      {isSelected && (
        <Box sx={{ position: 'absolute', top: 6, right: 6, color: BRAND, fontSize: 16 }}>
          <FiCheckCircle />
        </Box>
      )}
      <Typography
        sx={{
          fontWeight: isSelected ? 700 : 500,
          fontSize: '0.875rem',
          color: isSelected ? BRAND : 'text.secondary',
          textAlign: 'center',
        }}
      >
        {title}
      </Typography>
    </Paper>
  );
};

const ResumoPage = ({ proximoPasso }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [cpf, setCpf] = useState('');
  const [nomeCompleto, setNomeCompleto] = useState('');
  const [nome, setNome] = useState('');
  const [sobrenome, setSobrenome] = useState('');
  const [telefone, setTelefone] = useState('');
  const [email, setEmail] = useState('');
  const [cep, setCep] = useState('');
  const [dataNascimento, setDataNascimento] = useState('');
  const [rua, setRua] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [tipoPagamento, setTipoPagamento] = useState('');
  const [transportadora, setTransportadora] = useState('');
  const [cpfBuscado, setCpfBuscado] = React.useState('Inicial');
  const [parcelaSelecionada, setParcelaSelecionada] = useState('1');
  const valorFrete = useSelector(state => state.valorFrete);
  const [valorAjuste, setValorAjuste] = React.useState(0);
  const valorDesconto = useSelector(state => state.valorDesconto);
  const cartItems = useSelector(state => state.cartItems);
  const [tipoEntrega, setTipoEntrega] = useState("Retirada")
  const shippingId = useSelector(state => state.shippingId);
  const paymentId = useSelector(state => state.paymentId);
  const tipoEntrega2 = useSelector(state => state.tipoEntrega);
  const parcelas = validaParcelas(getValorTotal(cartItems, valorFrete, valorDesconto, valorAjuste));
  const [value, setValue] = useState(0);
  const [clienteId, setClienteId] = useState('');


  // ederreço cobrnaça
  const [addressIsCob, setAddressIsCob] = useState(null);
  const [cepCob, setCepCob] = useState('');
  const [ruaCob, setRuaCob] = useState('');
  const [numeroCob, setNumeroCob] = useState('');
  const [complementoCob, setComplementoCob] = useState('');
  const [bairroCob, setBairroCob] = useState('');
  const [cidadeCob, setCidadeCob] = useState('');
  const [estadoCob, setEstadoCob] = useState('');


  const [loadingCriarPedido, setLoadingCriarPedido] = useState(false);
  const [isPesquisaCrm, setIsPesquisaCrm] = useState(false);
  const [dataCrm, setDataCrm] = useState(false);
  const [stepCrm, setSetpCrm] = useState(0)
  const [openModalCrm, setOpenModalCrm] = useState(false);

  const [valorFreteRetirada, setValorFreteRetirada] = useState(0);
  const [retiradaGratis, setRetiradaGratis] = useState(false);
  const [entregaBloqueada, setEntregaBloqueada] = useState(false);
  const [loginMoovpay, setLoginMoovpay] = useState(null);

  const valorTotalGeral = getValorTotal(cartItems, valorFrete, valorDesconto, valorAjuste);

  // Estado para controlar mensagem de campos faltando
  const [camposFaltando, setCamposFaltando] = useState([]);
  const [mostrarMensagemCampos, setMostrarMensagemCampos] = useState(false);

  // Validar campos automaticamente quando os dados mudarem
  useEffect(() => {
    if (cpfBuscado === 'Buscado') {
      validarCamposObrigatorios();
    }
  }, [cpf, nome, sobrenome, telefone, email, cep, rua, numero, bairro, cidade, estado, tipoPagamento]);

  const voltarPdv = () => {
    history.push('frete')
  }


  const handleChange = (event, newValue) => {
    setTipoPagamento("");
    setValue(newValue);
  };

  const handleChangeAddressIsCob = (event) => {
    setAddressIsCob(event.target.checked);
    setBairroCob(bairro);
    setRuaCob(rua);
    setEstadoCob(estado);
    setCepCob(cep);
    setNumeroCob(numero);
    setCidadeCob(cidade);
    setComplementoCob(complemento);

  };

  const notifyError = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const notifyWarning = (message) => {
    toast.warning(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const validarEmail = (email) => {
    if (!email || email.trim() === '') {
      return { valido: false, mensagem: 'Email é obrigatório' };
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return { valido: false, mensagem: 'Email inválido' };
    }

    return { valido: true, mensagem: '' };
  };

  const validarCamposObrigatorios = () => {
    const camposFaltando = [];

    if (!cpf || cpf.trim() === '') camposFaltando.push('CPF');
    if (!nome || nome.trim() === '') camposFaltando.push('Nome');
    if (!sobrenome || sobrenome.trim() === '') camposFaltando.push('Sobrenome');
    if (!telefone || telefone.trim() === '') camposFaltando.push('Telefone');
    if (!email || email.trim() === '') camposFaltando.push('Email');
    if (!cep || cep.trim() === '') camposFaltando.push('CEP');
    if (!rua || rua.trim() === '') camposFaltando.push('Logradouro');
    if (!numero || numero.trim() === '') camposFaltando.push('Número');
    if (!bairro || bairro.trim() === '') camposFaltando.push('Bairro');
    if (!cidade || cidade.trim() === '') camposFaltando.push('Cidade');
    if (!estado || estado.trim() === '') camposFaltando.push('Estado');
    if (!tipoPagamento || tipoPagamento.trim() === '') camposFaltando.push('Forma de Pagamento');

    setCamposFaltando(camposFaltando);
    setMostrarMensagemCampos(camposFaltando.length > 0);

    return {
      valido: camposFaltando.length === 0,
      camposFaltando: camposFaltando
    };
  };


  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const limparCampos = () => {
    setNomeCompleto("");
    setTelefone("");
    setBairro("");
    setRua("");
    setEstado("");
    setCep("");
    setNumero("");
    setCidade("");
    setComplemento("");
    setEmail("");
  }

  const limparCamposCob = () => {
    setBairroCob("");
    setRuaCob("");
    setEstadoCob("");
    setCepCob("");
    setNumeroCob("");
    setCidadeCob("");
    setComplementoCob("");
  }

  const handleBuscaCep = async (zipCode) => {
    try {
      const address = await buscaCep(zipCode)
      if (address.erro) {
        alert('CEP ano encontrado!')
      } else {
        setCidade(address.localidade);
        setEstado(address.uf);
        return address;
      }
    } catch (address) {
      alert('CEP ano encontrado!');
    }
  }



  const buscarCpfMongo = () => {
    limparCampos();

    if (cpf.length === 11) {
      setCpfBuscado('Buscando');

      if (validarCPF(cpf) === true) {
        consultarClientePorCpf(soNumeros(cpf)).then(res => {
          if (res.data.isCliente) {
            setClienteId(res.data.data._id);
            setCpfBuscado('Buscado');
            setNome(res.data.data.first_name);
            setSobrenome(res.data.data.last_name);
            setTelefone(res.data.data.phone);
            setDataNascimento(res.data.data.data_nascimento);
            setBairro(res.data.data.endereco_entrega[0].bairro);
            setRua(res.data.data.endereco_entrega[0].logradouro);
            setEstado(res.data.data.endereco_entrega[0].uf);
            setCep(res.data.data.endereco_entrega[0].cep);
            setNumero(res.data.data.endereco_entrega[0].numero);
            setCidade(res.data.data.endereco_entrega[0].localidade);
            setComplemento(res.data.data.endereco_entrega[0].complemento);
            setEmail(res.data.data.email);
            console.log('res.data', res.data.data.phone)

          } else {
            notifyWarning("Esse CPF não possui cadastro no Venda Fácil, buscando em USE....");
            buscarCpfLinx();
            setClienteId('');
          }
        }).catch(err => {
          console.log(err);
          setCpfBuscado('Buscado');
          notifyError("Não foi possível estabelecer conexão com Venda Fácil");
        });
      } else {
        setCpfBuscado('Inicial');
        notifyError("CPF Digitado é inválido");
      }



    }
  }



  const buscarCpfLinx = async () => {
    limparCampos();
    if (cpf.length === 11) {
      setCpfBuscado('Buscando');
      setTimeout(() => {
        if (!cpfBuscado === 'Buscado')
          setCpfBuscado('Buscado');
      }, 10000);

      if (validarCPF(cpf) === true) {

        try {
          const response = await v2_actionCliente(soNumeros(cpf));
          const {data} = response.data
          if(response.status === 200) {
              setCpfBuscado('Buscado');
              setNomeCompleto(data.nome + " " + data.sobrenome);
              setNome(data.nome);
              setSobrenome(data.sobrenome);
              setTelefone(data.telefone1);
              setDataNascimento(moment((new Date(data.nascimento	)).toLocaleString('en-US', { timeZone: 'Europe/Berlin' })).format("DD/MM/YYYY"));
              setBairro(data.bairro);
              setRua(data.endereco);
              setEstado(data.estado);
              setCep(data.cep);
              setNumero(data.numero);
              setCidade(data.cidade);
              setComplemento(data.complemento);
              setEmail(data.email);
              dispatch({ type: Actions.SHIPPING_ID, shippingId: null });
          }
        } catch(err) {
          console.log(err);
          setCpfBuscado('Buscado');
          notifyError("Não foi possível estabelecer conexão com Linx");
        }

      } else {
        setCpfBuscado('Inicial');
        notifyError("CPF Digitado é inválido");
      }



    }
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const onStartPedido = async (id) => {

    try {
      let statusId = "60774fa684e6861cb41a472f";
      let shippingPrice = valorFrete;
      let items = cartItems;
      let parcelas = parcelaSelecionada;
      let desconto = valorDesconto;
      let responseZoop = null;
      let dadosOrigemPedido = {
        cpf: getDataUsuario().cpf,
        filial: getDataUsuario().filial,
        nome: getDataUsuario().nome,
        sobrenome: getDataUsuario().sobrenome
      }

      let personalData = {
        full_name: nome + " " + sobrenome,
        nome: nome,
        sobrenome: sobrenome,
        mobile: telefone,
        cpf: soNumeros(cpf),
        email: email ? email : ""
      }

      let shippingAddress = {
        full_name: nomeCompleto,
        address1: rua,
        address2: bairro,
        city: cidade,
        country: "Brazil",
        postal_code: cep,
        state: estado,
        phone: soNumeros(telefone),
        number: soNumeros(numero),
        company: "",
        tax_number: "",
        coordinates: {
          latitude: "",
          longitude: ""
        },
        details: complemento

      }

      let billingAddress = {

        full_name: nomeCompleto,
        address1: rua,
        address2: bairro,
        city: cidade,
        country: "Brazil",
        postal_code: cep,
        state: estado,
        phone: telefone,
        number: numero,
        company: "",
        tax_number: "",
        coordinates: {
          latitude: "",
          longitude: ""
        },
        details: complemento,
      }

      let dataToSend = { customerId: id, desconto, billingAddress, shippingAddress, personalData, items, shippingPrice, statusId, tipoEntrega:tipoEntrega2, shippingId, paymentId, parcelas, responseZoop, dadosOrigemPedido }

      console.log('dataToSend', dataToSend)

      const responsePedido = await criarPedido(dataToSend)
      setLoadingCriarPedido(false)


      if (responsePedido) {
        setLoadingCriarPedido(false)
        dispatch({ type: Actions.ORDER_NUMBER, orderNumber: responsePedido.data.number });
        dispatch({ type: Actions.MEU_CARRINHO, cartItems: [] });
        history.push(`/pdv/conclusao?order=${responsePedido.data.number}`);
      }

    } catch (error) {
      setLoadingCriarPedido(false);
      alert('Erro ao Criar Pedido, tente novamente. Caso o erro persista, entre em contato com o suporte');
      console.log('error', error)
    }

  }

  const onCriarCliente = async () => {
    let data = {
      email,
      phone: telefone,
      nome,
      sobrenome,
      password: null,
      data_nascimento: dataNascimento,
      cpf: cpf,
      endereco_entrega: [{
        logradouro: rua,
        numero: numero,
        bairro: bairro,
        localidade: cidade,
        cep: cep,
        uf: estado,
        complemento: complemento
      }],
      endereco_cobranca: [{
        logradouro: ruaCob,
        numero: numeroCob,
        bairro: bairroCob,
        localidade: cidadeCob,
        cep: cepCob,
        uf: estadoCob,
        complemento: complementoCob
      }]
    }

    try {
      const res = await criarCliente(data);
      await onStartPedido(res.data.data._id);
      setClienteId(res.data.data._id);
      console.log('Resultado cadstro de cliente', res.data)
    } catch (error) {
      notifyError("Erro ao cadastrar no Venda Fácil");
    }

  }

  const onEditarCliente = async () => {
    let data = {
      email,
      phone: telefone,
      nome,
      sobrenome,
      password: null,
      data_nascimento: dataNascimento,
      cpf: cpf,
      endereco_entrega: [{
        logradouro: rua,
        numero: numero,
        bairro: bairro,
        localidade: cidade,
        cep: cep,
        uf: estado,
        complemento: complemento
      }],
      endereco_cobranca: [{
        logradouro: ruaCob,
        numero: numeroCob,
        bairro: bairroCob,
        localidade: cidadeCob,
        cep: cepCob,
        uf: estadoCob,
        complemento: complementoCob
      }]
    }

    try {
      const res = await editarCliente(clienteId, data);
    } catch (error) {
      notifyError("Erro ao cadastrar no Venda Fácil");
    }

  }

  const fazerPedido = async () => {
    // Validar todos os campos obrigatórios
    const validacaoCampos = validarCamposObrigatorios();
    if (!validacaoCampos.valido) {
      return; // A mensagem já é mostrada na tela pela função validarCamposObrigatorios
    }

    // Validar email antes de prosseguir
    const validacaoEmail = validarEmail(email);
    if (!validacaoEmail.valido) {
      notifyError(validacaoEmail.mensagem);
      return;
    }

    setLoadingCriarPedido(true)
    if (clienteId) {
      try {
        await onEditarCliente();
        await onStartPedido(clienteId);

      } catch (error) {
        setLoadingCriarPedido(false)
        alert('Erro ao cadastrar cliente');
        console.log('erro ao cadastar cliente')
      }
    } else {

      try {
        await onCriarCliente();
        setLoadingCriarPedido(false)
      } catch (error) {
        setLoadingCriarPedido(false)
        alert('Erro ao cadastrar cliente');
        console.log('erro ao cadastar cliente')
      }
    }
  }




  const handleChangeParcelas = (event) => {
    setParcelaSelecionada(event.target.value);
  };


  const handleCartaoCredito = () => {
    setTipoPagamento('Cartão Crédito')
    setParcelaSelecionada("1");
    dispatch({ type: Actions.PAYMENT_ID, paymentId: "6168e68dbec438dc351a3065" });
  }

  const handleCartaoDebito = () => {
    setTipoPagamento('Cartão Débito');
    setParcelaSelecionada("1");
    dispatch({ type: Actions.PAYMENT_ID, paymentId: "6168e69ebec438dc351a3066" });
  }

  const handlePixCheckout = () => {
    setTipoPagamento('Pix Checkout');
    setParcelaSelecionada("1");
    dispatch({ type: Actions.PAYMENT_ID, paymentId: "62c753914e8a07e77586dc82" });
  }

  const handleMoovpay = () => {
    setTipoPagamento('Moovpay');
    setParcelaSelecionada("1");
    dispatch({ type: Actions.PAYMENT_ID, paymentId: "65ef574e94335d158c264b32" });
    hanldeLoginMoovpay();
  }

  const handleLinkPagamento = () => {
    dispatch({ type: Actions.PAYMENT_ID, paymentId: "6168e6afbec438dc351a3067" });
    setTipoPagamento('Link Pagamento')
  }



  const handleEscolhePropria = () => {
    if (retiradaGratis) {
      setValorFreteRetirada(0);
      dispatch({ type: Actions.TIPO_ENTREGA, tipoEntrega: "Retirada" });
      setTipoEntrega('Retirada');
      setTransportadora('Total');
      dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
      dispatch({ type: Actions.SHIPPING_ID, shippingId: "61560325eaf72f4fe7f5ee27" });
      return;
    }
    setTransportadora('Total');
    dispatch({ type: Actions.SHIPPING_ID, shippingId: "61560325eaf72f4fe7f5ee27" });
    dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })

    if (tipoEntrega === "Retirada") {
      if (getCepUser() >= 35500000 & getCepUser() <= 35505000) {
        dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
      } else {
        if (getValorSubTotal(cartItems) < 149) {
          dispatch({ type: Actions.valorFrete, valorFrete: 20.00 })
        } else {
          dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
        }
      }
    }


    if (tipoEntrega === 'Entrega') {
      if (cep >= 35500000 & cep <= 35505000) {
        if (getValorSubTotal(cartItems) < 199) {
          dispatch({ type: Actions.valorFrete, valorFrete: 14.00 })
        } else {
          dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
        }
      } else {
        if (getValorSubTotal(cartItems) < 199) {
          dispatch({ type: Actions.valorFrete, valorFrete: 20.00 })
        } else {
          dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
        }
      }
    }
  }

  async function hanldeLoginMoovpay() {
       try {
        let data = {
          "scope": {
          "valor": valorTotalGeral,
          "cpf": cpf
          }
        }
        const response = await actionLoginMoovpay(data);
        if(response.status === 200) {
          setLoginMoovpay(response.data.data)
        }
       } catch (error) {
         alert('Erro ao autenticar no Moovpay entre em contato com o suporte')
       }
  }

  // ====== RENDER ======
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>

      {/* ====== HEADER ====== */}
      <Box sx={{
        width: '100%',
        bgcolor: '#fff',
        py: 1.5,
        px: 2,
        borderBottom: '1px solid #e5e5e5',
      }}>
        <Box sx={{ maxWidth: '98%', mx: 'auto' }}>
          <Stack justifyContent="space-between" alignItems="center" direction="row">
            <IconButton onClick={voltarPdv} sx={{ color: '#333' }}>
              <FiArrowLeftCircle size={28} />
            </IconButton>
            <Stepper valorStep={2} />
          </Stack>
        </Box>
      </Box>

      {/* Loading bar */}
      <Collapse in={cpfBuscado === 'Buscando'}>
        <LinearProgress sx={{ height: 3, '& .MuiLinearProgress-bar': { bgcolor: ACCENT }, bgcolor: '#e0e0e0' }} />
      </Collapse>

      {/* ====== CONTENT ====== */}
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
        <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2.5} alignItems="flex-start">

          {/* ====== LEFT: Customer Data ====== */}
          <Box sx={{ width: { xs: '100%', lg: '42%' } }}>
            <Card sx={cardSx}>

              {/* CPF Search */}
              <Box sx={sectionHeaderSx}>
                <Avatar sx={sectionIconSx}><FiSearch size={18} /></Avatar>
                <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1rem' }}>
                  Identificação do Cliente
                </Typography>
              </Box>

              <Stack direction="row" spacing={1.5} alignItems="center">
                <TextField
                  fullWidth variant="outlined" label="CPF do Cliente" size="small"
                  placeholder="000.000.000-00"
                  value={maskCPF(cpf)}
                  onChange={e => setCpf(soNumeros(e.target.value))}
                  sx={inputSx}
                />
                <Button
                  onClick={buscarCpfMongo}
                  disabled={cpfBuscado === 'Buscando'}
                  variant="contained"
                  size="large"
                  sx={{
                    minWidth: 130, height: 40, borderRadius: 1.5,
                    textTransform: 'none', fontWeight: 600,
                    bgcolor: BRAND, '&:hover': { bgcolor: BRAND_HOVER },
                  }}
                >
                  {cpfBuscado === 'Buscando' ? <CircularProgress size={22} sx={{ color: '#fff' }} /> : 'Pesquisar'}
                </Button>
              </Stack>

              {/* Customer form after CPF search */}
              <Collapse in={cpfBuscado === 'Buscado'}>
                <Fade in={cpfBuscado === 'Buscado'} timeout={500}>
                  <Box>

                    {/* Personal Info */}
                    <Divider sx={{ my: 3 }} />
                    <Box sx={sectionHeaderSx}>
                      <Avatar sx={sectionIconSx}><FiUser size={18} /></Avatar>
                      <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1rem' }}>
                        Informações Pessoais
                      </Typography>
                    </Box>

                    <Grid container spacing={2}>
                      <Grid item md={6} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Nome" value={nome} size="small" onChange={e => setNome(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={6} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Sobrenome" value={sobrenome} size="small" onChange={e => setSobrenome(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Data Nasc." value={dataNascimento} size="small" onChange={e => setDataNascimento(maskDate(e.target.value))} sx={inputSx} />
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Telefone" value={phoneMask(telefone)} size="small" onChange={e => setTelefone(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Email" value={email} size="small" onChange={e => setEmail(e.target.value)} sx={inputSx} />
                      </Grid>
                    </Grid>

                    {/* Shipping Address */}
                    <Divider sx={{ my: 3 }} />
                    <Box sx={sectionHeaderSx}>
                      <Avatar sx={sectionIconSx}><FiMapPin size={18} /></Avatar>
                      <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1rem' }}>
                        Endereço de Entrega
                      </Typography>
                    </Box>

                    <Grid container spacing={2}>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField
                          fullWidth variant="outlined" label="CEP" value={cep} size="small"
                          onChange={e => setCep(e.target.value)}
                          onBlur={() => {
                            if (cep.length === 8) {
                              buscaCep(cep).then(res => {
                                setBairro(res.bairro); setRua(res.logradouro);
                                setEstado(res.uf); setCidade(res.localidade);
                                setComplemento(""); setNumero("");
                              }).catch(e => console.log(e))
                            }
                          }}
                          sx={inputSx}
                        />
                      </Grid>
                      <Grid item md={8} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Logradouro" value={rua} size="small" onChange={e => setRua(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Bairro" value={bairro} size="small" onChange={e => setBairro(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={4} xs={4}>
                        <TextField fullWidth variant="outlined" label="Número" value={numero} size="small" onChange={e => setNumero(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={8} xs={8}>
                        <TextField fullWidth variant="outlined" label="Complemento" value={complemento} size="small" onChange={e => setComplemento(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={8} xs={8}>
                        <TextField fullWidth variant="outlined" label="Cidade" value={cidade} size="small" onChange={e => setCidade(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={4} xs={4}>
                        <TextField fullWidth variant="outlined" label="Estado" value={estado} size="small" onChange={e => setEstado(e.target.value)} sx={inputSx} />
                      </Grid>
                    </Grid>

                    {/* Same address checkbox */}
                    <FormControlLabel
                      sx={{ mt: 2, '& .MuiTypography-root': { fontSize: '0.875rem', color: 'text.secondary' } }}
                      control={
                        <Checkbox checked={addressIsCob} onChange={handleChangeAddressIsCob} name="checkedB"
                          sx={{ '&.Mui-checked': { color: BRAND } }} />
                      }
                      label="Endereço de entrega é o mesmo de cobrança"
                    />

                    {/* Billing Address */}
                    <Divider sx={{ my: 3 }} />
                    <Box sx={sectionHeaderSx}>
                      <Avatar sx={sectionIconSx}><FiMapPin size={18} /></Avatar>
                      <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1rem' }}>
                        Endereço de Cobrança
                      </Typography>
                    </Box>

                    <Grid container spacing={2}>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField
                          fullWidth variant="outlined" label="CEP" value={cepCob} size="small"
                          onChange={e => setCepCob(e.target.value)}
                          onBlur={() => {
                            if (cepCob.length === 8) {
                              buscaCep(cepCob).then(res => {
                                setBairroCob(res.bairro); setRuaCob(res.logradouro);
                                setEstadoCob(res.uf); setCidadeCob(res.localidade);
                                setComplementoCob(""); setNumeroCob("");
                              }).catch(e => console.log(e))
                            }
                          }}
                          sx={inputSx}
                        />
                      </Grid>
                      <Grid item md={8} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Logradouro" value={ruaCob} size="small" onChange={e => setRuaCob(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Bairro" value={bairroCob} size="small" onChange={e => setBairroCob(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={4} xs={4}>
                        <TextField fullWidth variant="outlined" label="Número" value={numeroCob} size="small" onChange={e => setNumeroCob(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={8} xs={8}>
                        <TextField fullWidth variant="outlined" label="Complemento" value={complementoCob} size="small" onChange={e => setComplementoCob(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={8} xs={8}>
                        <TextField fullWidth variant="outlined" label="Cidade" value={cidadeCob} size="small" onChange={e => setCidadeCob(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={4} xs={4}>
                        <TextField fullWidth variant="outlined" label="Estado" value={estadoCob} size="small" onChange={e => setEstadoCob(e.target.value)} sx={inputSx} />
                      </Grid>
                    </Grid>

                  </Box>
                </Fade>
              </Collapse>

              {/* Missing fields warning */}
              <Collapse in={mostrarMensagemCampos}>
                <Box sx={{
                  mt: 3, p: 2, borderRadius: 1.5,
                  bgcolor: '#fef3c7', border: '1px solid #fcd34d',
                  display: 'flex', alignItems: 'flex-start', gap: 1.5,
                }}>
                  <FiAlertCircle size={20} style={{ color: '#d97706', marginTop: 2, flexShrink: 0 }} />
                  <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', color: '#92400e', mb: 0.5 }}>
                      Campos obrigatórios não preenchidos
                    </Typography>
                    <Typography sx={{ fontSize: '0.8rem', color: '#a16207' }}>
                      {camposFaltando.join(' · ')}
                    </Typography>
                  </Box>
                </Box>
              </Collapse>

            </Card>
          </Box>

          {/* ====== MIDDLE: Shipping + Payment ====== */}
          <Box sx={{ width: { xs: '100%', lg: '38%' } }}>
            <Stack spacing={2.5}>

              {/* Shipping */}
              <Collapse in={cpfBuscado === 'Buscado'}>
                <Card sx={cardSx}>
                  <Box sx={sectionHeaderSx}>
                    <Avatar sx={sectionIconSx}><FiTruck size={18} /></Avatar>
                    <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1rem' }}>
                      Forma de Entrega
                    </Typography>
                  </Box>
                  <CheckoutShipping />
                </Card>
              </Collapse>

              {/* Payment */}
              {shippingId && cpf !== "" && cep !== "" && rua !== "" && numero !== "" && telefone && nome !== "" && sobrenome !== "" && (
                <Fade in timeout={400}>
                  <Card sx={cardSx}>
                    <Box sx={sectionHeaderSx}>
                      <Avatar sx={sectionIconSx}><FiCreditCard size={18} /></Avatar>
                      <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1rem' }}>
                        Forma de Pagamento
                      </Typography>
                    </Box>

                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="payment tabs"
                      sx={{
                        mb: 2.5,
                        '& .MuiTabs-indicator': { bgcolor: BRAND, height: 2.5 },
                        '& .MuiTab-root': {
                          textTransform: 'none', fontWeight: 600, fontSize: '0.9rem',
                          color: 'text.secondary',
                          '&.Mui-selected': { color: BRAND },
                        },
                      }}
                    >
                      <Tab label="Na Loja" {...a11yProps(0)} />
                      <Tab label="Online" {...a11yProps(1)} />
                    </Tabs>

                    <TabPanel value={value} index={0}>
                      <Stack spacing={2}>
                        {getIsMaquininhaUser() === "false" && (
                          <Box sx={{
                            p: 2, borderRadius: 1.5, bgcolor: '#eff6ff',
                            border: '1px solid #bfdbfe', fontSize: '0.85rem', color: '#1e40af',
                          }}>
                            Sua loja não possui maquininha física. Utilize o Link de Pagamento para crédito ou a opção Pix abaixo.
                          </Box>
                        )}
                        <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
                          {getIsMaquininhaUser() === "true" && (
                            <ItemPaymentType
                              title="Crédito"
                              onClick={handleCartaoCredito}
                              background={tipoPagamento == 'Cartão Crédito' ? '#b6ffca' : ''}
                            />
                          )}
                          {getIsMaquininhaUser() === "true" && (
                            <ItemPaymentType
                              title="Débito"
                              onClick={handleCartaoDebito}
                              background={tipoPagamento == 'Cartão Débito' ? '#b6ffca' : ''}
                            />
                          )}
                          <ItemPaymentType
                            title="Pix"
                            onClick={handlePixCheckout}
                            background={tipoPagamento == 'Pix Checkout' ? '#b6ffca' : ''}
                          />
                          <ItemPaymentType
                            title="MoovPay"
                            onClick={handleMoovpay}
                            background={tipoPagamento == 'Moovpay' ? '#b6ffca' : ''}
                          />
                        </Stack>
                      </Stack>
                    </TabPanel>

                    <TabPanel value={value} index={1}>
                      <ItemPaymentType
                        title="Link Pagamento"
                        onClick={handleLinkPagamento}
                        background={tipoPagamento == 'Link Pagamento' ? '#b6ffca' : ''}
                      />
                    </TabPanel>

                    {/* Installments - Crédito */}
                    <Collapse in={tipoPagamento === 'Cartão Crédito'}>
                      <Box sx={{ mt: 2 }}>
                        {parcelas && (
                          <FormControl fullWidth size="small">
                            <InputLabel sx={{ '&.Mui-focused': { color: BRAND } }}>Parcelas</InputLabel>
                            <Select
                              value={parcelaSelecionada}
                              onChange={handleChangeParcelas}
                              label="Parcelas"
                              sx={{ borderRadius: 1.5, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: BRAND } }}
                            >
                              {parcelas.parcelas.map((parcelas) => (
                                <MenuItem key={parcelas.quantidade} value={parcelas.quantidade}>
                                  {parcelas.quantidade}x de R${parcelas.valor} sem juros
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </Box>
                    </Collapse>

                    {/* Installments - MoovPay */}
                    <Collapse in={tipoPagamento === 'Moovpay'}>
                      <Box sx={{ mt: 2 }}>
                        {loginMoovpay?.parcelamentos && (
                          <FormControl fullWidth size="small">
                            <InputLabel sx={{ '&.Mui-focused': { color: BRAND } }}>Parcelas</InputLabel>
                            <Select
                              value={parcelaSelecionada}
                              onChange={handleChangeParcelas}
                              label="Parcelas"
                              sx={{ borderRadius: 1.5, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: BRAND } }}
                            >
                              {loginMoovpay?.parcelamentos.map((parcelas) => (
                                <MenuItem key={parcelas.QuantidadeParcelas} value={parcelas.QuantidadeParcelas}>
                                  {parcelas.QuantidadeParcelas}x de R${parcelas.ValorParcela} {parcelas.IndicadorJuros ? "com juros" : "sem juros"}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </Box>
                    </Collapse>

                    {/* Link Pagamento info */}
                    <Collapse in={tipoPagamento === 'Link Pagamento'}>
                      <Box sx={{
                        mt: 2, p: 2, borderRadius: 1.5,
                        bgcolor: '#f0fdf4', border: '1px solid #bbf7d0',
                        fontSize: '0.85rem', color: '#166534',
                      }}>
                        Após a confirmação, será gerado um link de pagamento Katuxa Pay para compartilhar com o cliente.
                      </Box>
                    </Collapse>

                    {/* Submit Button */}
                    {cpf !== "" && cep !== "" && tipoPagamento !== "" && rua !== "" && numero !== "" && telefone && nome !== "" && sobrenome !== "" && email !== "" && validarEmail(email).valido && (
                      <Button
                        fullWidth variant="contained" onClick={fazerPedido} disabled={loadingCriarPedido}
                        sx={{
                          mt: 3, py: 1.5, borderRadius: 1.5,
                          textTransform: 'none', fontWeight: 700, fontSize: '1rem',
                          bgcolor: BRAND,
                          '&:hover': { bgcolor: BRAND_HOVER },
                          '&:disabled': { bgcolor: '#d1d5db' },
                        }}
                      >
                        {loadingCriarPedido ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Confirmar Pedido'}
                      </Button>
                    )}

                  </Card>
                </Fade>
              )}

            </Stack>
          </Box>

          {/* ====== RIGHT: Cart Summary ====== */}
          <Box sx={{ width: { xs: '100%', lg: '20%' } }}>
            <Card sx={{
              ...cardSx,
              position: { lg: 'sticky' },
              top: { lg: 16 },
            }}>
              <Box sx={sectionHeaderSx}>
                <Avatar sx={sectionIconSx}><FiShoppingBag size={18} /></Avatar>
                <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1rem' }}>
                  Resumo
                </Typography>
              </Box>
              <CartResumo />
            </Card>
          </Box>

        </Stack>
      </Box>
    </Box>
  )
}

export default ResumoPage;
